import { ComponentType } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { Button } from '../ui/button';
import { Link } from 'react-router-dom';

interface SideBarLinkItemProps {
  Icon: ComponentType<{ className?: string }>;
  linkText: string;
  linkTo: string;
  toolTip: string;
  isDisabled?: boolean;
  isFocused?: boolean;
}

export const SideBarLinkItem = ({ Icon, linkText, linkTo, toolTip, isDisabled = false, isFocused = false }: SideBarLinkItemProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button disabled={isDisabled} asChild variant="ghost" className="h-[50px] w-full justify-center md:justify-start gap-2 rounded-none px-0 md:px-5 text-base">
          <Link
            to={linkTo}
          >
            <Icon className="mr-4 inline-block h-4 w-4" />
            <span className={`hover:bg-curtin-tints-blue-light hidden md:flex items-center text-curtin-primary-black-90 hover:text-curtin-purple active:bg-white
              ${
                isFocused ? 'text-curtin-purple' : 'text-curtin-primary-black-90'
              }`}
>
            {linkText}
            </span>
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="right">{toolTip}</TooltipContent>
    </Tooltip>
  );
};
